import { create } from 'zustand';

export interface AuthUser {
  id: number;
  email: string;
  displayName: string;
  locale: 'tr' | 'en';
  theme: 'light' | 'dark' | 'system';
  units: 'metric' | 'imperial';
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  setAccessToken: (token: string | null) => void;
  setUser: (user: AuthUser | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setAccessToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null }),
}));
